/** The "620" mark: amber outlined mono lockup (mockup .mark). Amber = brand, one of its reserved uses. */
export function BrandMark({ showText = true }: { showText?: boolean }) {
  return (
    <div className="flex items-center gap-2">
      <span className="rounded-[3px] border-[1.5px] border-accent px-1 py-[3px] font-mono text-xs/none font-bold tracking-[.02em] text-accent">
        620
      </span>
      {showText && (
        <div className="leading-none">
          <b className="block text-sm font-semibold">Command Center</b>
          <small className="mt-0.5 block text-2xs text-fg-muted">620 Fabrication</small>
        </div>
      )}
    </div>
  );
}
